import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type ConfidenceScoreProps = {
  score: number;
  label: string;
};
const LOW_SCORE_UPPER_BOUND = 50;
const MEDIUM_SCORE_UPPER_BOUND = 84;
const ConfidenceScore = t0 => {
  const $ = _c(17);
  const {
    score,
    label
  } = t0;
  const getTextColor = _temp;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== label || $[1] !== score) {
    const textColor = getTextColor(score);
    if ($[6] !== label) {
      t4 = <span className="text-label-2 text-tertiary">{label}</span>;
      $[6] = label;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t2 = "flex justify-start items-end";
    t3 = <span className={cx("text-heading-1", textColor)}>{score}/</span>;
    t1 = cx("text-heading-3", textColor);
    $[0] = label;
    $[1] = score;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t1) {
    t5 = <span className={t1}>100</span>;
    $[8] = t1;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default ConfidenceScore;
function _temp(score_0) {
  if (score_0 > MEDIUM_SCORE_UPPER_BOUND) {
    return "text-success";
  }
  if (score_0 >= LOW_SCORE_UPPER_BOUND) {
    return "text-warning";
  }
  return "text-error";
}